import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * ProgressStepDots
 * 
 * A visual progress indicator showing completed steps as dots.
 * 
 * Props:
 *  - completed: Number of completed steps
 *  - total: Total number of steps
 *  - variant: Color variant ('green' | 'purple' | 'primary')
 *  - size: Dot size ('sm' | 'md' | 'lg')
 *  - className: Additional CSS classes
 */
export default function ProgressStepDots({
  completed = 0,
  total = 1,
  variant = 'green',
  size = 'md',
  className = '',
}) {
  return (
    <div className={classNames('progress-step-dots', `progress-step-dots-${size}`, className)}>
      {Array.from({ length: total }).map((_, idx) => (
        <div
          key={idx}
          className={classNames('progress-step-dot', `progress-step-dot-${variant}`, {
            'completed': idx < completed,
          })}
        />
      ))}
    </div>
  );
}

ProgressStepDots.propTypes = {
  completed: PropTypes.number,
  total: PropTypes.number,
  variant: PropTypes.oneOf(['green', 'purple', 'primary']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};
